import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const EmergingTrendsChart = () => {
  // Dummy Data
  const trends = [
    { name: "AI Ethics", x: 1, y: 85, category: "Risk" },
    { name: "Green Tech", x: 2, y: 95, category: "Opportunity" },
    { name: "Crypto Regulation", x: 3, y: 75, category: "Risk" },
    { name: "Remote Work", x: 4, y: 88, category: "Opportunity" },
    { name: "Supply Chain Issues", x: 5, y: 70, category: "Risk" },
    { name: "5G Expansion", x: 6, y: 92, category: "Opportunity" },
    { name: "Quantum Computing", x: 7, y: 85, category: "Opportunity" },
    { name: "Climate Policies", x: 8, y: 77, category: "Risk" },
    { name: "Metaverse Growth", x: 9, y: 89, category: "Opportunity" },
    { name: "Biotech Advances", x: 10, y: 84, category: "Opportunity" },
    { name: "Data Breaches", x: 11, y: 68, category: "Risk" },
    { name: "Autonomous Vehicles", x: 12, y: 90, category: "Opportunity" },
    { name: "Healthcare AI", x: 13, y: 87, category: "Opportunity" },
    { name: "Political Instability", x: 14, y: 65, category: "Risk" },
    { name: "Renewable Energy", x: 15, y: 91, category: "Opportunity" },
    { name: "Workforce Automation", x: 16, y: 80, category: "Risk" },
    { name: "E-commerce Boom", x: 17, y: 94, category: "Opportunity" },
    { name: "Water Scarcity", x: 18, y: 72, category: "Risk" },
    { name: "Virtual Events", x: 19, y: 86, category: "Opportunity" },
    { name: "AI in Education", x: 20, y: 83, category: "Opportunity" },
    { name: "Digital Currencies", x: 21, y: 76, category: "Risk" },
    { name: "Agritech Solutions", x: 22, y: 88, category: "Opportunity" },
    { name: "Geopolitical Tensions", x: 23, y: 67, category: "Risk" },
    { name: "Space Exploration", x: 24, y: 90, category: "Opportunity" },
    { name: "Ethical Hacking", x: 25, y: 85, category: "Opportunity" },
    { name: "Remote Healthcare", x: 26, y: 92, category: "Opportunity" },
    { name: "Economic Uncertainty", x: 27, y: 64, category: "Risk" },
    { name: "Cloud Adoption", x: 28, y: 87, category: "Opportunity" },
    { name: "Food Security", x: 29, y: 70, category: "Risk" },
    { name: "Wearable Technology", x: 30, y: 84, category: "Opportunity" },
    { name: "Smart Cities", x: 31, y: 89, category: "Opportunity" },
    { name: "Energy Storage", x: 32, y: 91, category: "Opportunity" },
    { name: "Deepfake Risks", x: 33, y: 63, category: "Risk" },
    { name: "Bioplastics", x: 34, y: 79, category: "Opportunity" },
    { name: "Cyber Warfare", x: 35, y: 65, category: "Risk" },
    { name: "Blockchain Adoption", x: 36, y: 86, category: "Opportunity" },
    { name: "AI in Agriculture", x: 37, y: 82, category: "Opportunity" },
    { name: "Rising Inflation", x: 38, y: 60, category: "Risk" },
    { name: "3D Printing", x: 39, y: 88, category: "Opportunity" },
    { name: "Mental Health Tech", x: 40, y: 89, category: "Opportunity" },
    { name: "Natural Disasters", x: 41, y: 66, category: "Risk" },
    { name: "Electric Vehicles", x: 42, y: 94, category: "Opportunity" },
    { name: "Hybrid Work Culture", x: 43, y: 82, category: "Opportunity" },
    { name: "Data Privacy", x: 44, y: 73, category: "Risk" },
    { name: "Circular Economy", x: 45, y: 87, category: "Opportunity" },
    { name: "Fake News Spread", x: 46, y: 62, category: "Risk" },
    { name: "Genomics Research", x: 47, y: 88, category: "Opportunity" },
    { name: "Digital Twin Tech", x: 48, y: 83, category: "Opportunity" },
    { name: "Retail Tech", x: 49, y: 90, category: "Opportunity" },
    { name: "Pandemic Aftermath", x: 50, y: 69, category: "Risk" },
    { name: "Drones for Delivery", x: 51, y: 89, category: "Opportunity" },
    { name: "Climate Migration", x: 52, y: 64, category: "Risk" },
    { name: "Streaming Wars", x: 53, y: 78, category: "Risk" },
    { name: "AI in Art", x: 54, y: 81, category: "Opportunity" },
    { name: "Space Mining", x: 55, y: 92, category: "Opportunity" },
    { name: "Supply Chain AI", x: 56, y: 86, category: "Opportunity" },
  ];

  // Separate Data by Category
  const riskData = trends
    .filter((trend) => trend.category === "Risk")
    .map((trend) => ({
      name: trend.name,
      x: trend.x,
      y: trend.y,
    }));

  const opportunityData = trends
    .filter((trend) => trend.category === "Opportunity")
    .map((trend) => ({
      name: trend.name,
      x: trend.x,
      y: trend.y,
    }));

  // Highcharts Configuration
  const options = {
    chart: {
      type: "scatter", // Scatter plot
      zoomType: "xy", // Enable zooming
    },
    title: {
      text: "",
    },
    // subtitle: {
    //   text: "Lists new trends that have recently emerged, categorized as potential risks or opportunities.",
    // },
    xAxis: {
      title: {
        text: "Trend Index",
      },
      tickInterval: 1,
    },
    yAxis: {
      title: {
        text: "Impact Score",
      },
    },
    tooltip: {
      pointFormat:
        "<b>{point.name}</b>: {point.y} Impact (Category: {series.name})",
    },
    legend: {
      title: {
        text: "Categories",
      },
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 8, // Size of the markers
          symbol: "circle", // Shape of the markers
        },
        dataLabels: {
          enabled: true,
          format: "{point.name}", // Show the trend name on the plot
        },
      },
    },
    series: [
      {
        name: "Risk",
        color: "#dc3545", // Red for risks
        data: riskData,
      },
      {
        name: "Opportunity",
        color: "#28a745", // Green for opportunities
        data: opportunityData,
      },
    ],
    credits: {
      enabled: false, // Disable Highcharts watermark
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default EmergingTrendsChart;
